import { Component } from '@angular/core';
import { PairingChallengeContainerComponent } from '@era/devices';

@Component({
  selector: 'era-pair-confirm-page',
  templateUrl: './confirm.page.html',
  styleUrls: ['./confirm.page.scss'],
  imports: [PairingChallengeContainerComponent],
})
export class PairConfirmPage {}
